import { defineMessages } from "react-intl";

// Printer set-up tips for the label page. <b>…</b> marks the words to find
// in the printer's own screens.
export const helpMessages = defineMessages({
  title: {
    id: "DzBN6b",
    defaultMessage: "Printing tips",
    description: "label printing help page, title and button",
  },
  zebraSubtitle: {
    id: "jjrq55",
    defaultMessage: "Thermal label printer · 50×30 roll",
    description: "label printing help, subtitle under the Zebra GC420d printer name",
  },
  groupSetup: {
    id: "rtEtbl",
    defaultMessage: "Set-up (once per computer)",
    description: "label printing help, group of printer set-up sections",
  },
  groupPrinting: {
    id: "XklkNL",
    defaultMessage: "Printing",
    description: "label printing help, group of everyday printing sections",
  },
  groupTrouble: {
    id: "5QInOS",
    defaultMessage: "Troubleshooting",
    description: "label printing help, group of problem-solving sections",
  },
  openHelp: {
    id: "QNRkoM",
    defaultMessage: "How to set up the printer",
    description: "label printing page, link to the printer help next to the paper size",
  },

  windowsTitle: {
    id: "7c8x1/",
    defaultMessage: "Windows",
    description: "label printing help, section title",
  },
  windowsStep1: {
    id: "tI+/iP",
    defaultMessage:
      "Open Settings → Printers & scanners → ZDesigner GC420d → <b>Printing preferences</b>. These are the driver's settings, not Chrome's print window.",
    description: "label printing help, Windows step",
  },
  windowsStep2: {
    id: "JuEydl",
    defaultMessage:
      "<b>Page Setup → Stocks → New</b>: name “50x30 2x2”, width <b>102 mm</b>, height <b>62 mm</b>, unprintable area 0. The width is the side across the roll.",
    description: "label printing help, Windows step",
  },
  windowsStep3: {
    id: "xlklPE",
    defaultMessage:
      "Select that stock, orientation <b>Portrait</b>, “Rotate 180°” unticked, then <b>Apply</b>.",
    description: "label printing help, Windows step",
  },
  windowsStep4: {
    id: "QdNk3m",
    defaultMessage:
      "<b>Advanced Setup</b>: media <b>Labels with gaps</b> and print method <b>Direct thermal</b> (rolls without ribbon), then <b>Apply</b>.",
    description: "label printing help, Windows step",
  },

  chromeTitle: {
    id: "zeDTSr",
    defaultMessage: "Printing from the dashboard",
    description: "label printing help, section title",
  },
  chromeStep1: {
    id: "GszUHf",
    defaultMessage:
      "Pick the template and the paper <b>Label roll 50×30</b> (choosing a 50×30 template selects it). Under <b>Adjust</b>: 2 labels per row, 2 rows per page, left and right margin 0.5 mm, gaps 1 mm. These stay remembered.",
    description: "label printing help, printing step",
  },
  chromeStep2: {
    id: "JvSQui",
    defaultMessage:
      "In the print window: printer <b>ZDesigner GC420d</b>, paper <b>50x30 2x2</b>, margins <b>None</b>, scale <b>Default</b>.",
    description: "label printing help, printing step",
  },
  chromeStep3: {
    id: "MpLaw/",
    defaultMessage:
      "The paper size to use is always the one shown next to “Copy size” on the label page.",
    description: "label printing help, printing step",
  },

  calibrateTitle: {
    id: "qEiyKV",
    defaultMessage: "Calibrate after loading a roll",
    description: "label printing help, section title",
  },
  calibrateStep1: {
    id: "qSrWpv",
    defaultMessage:
      "Hold the green button until the light flashes <b>twice</b>, then let go. The printer feeds a few labels and learns where the gaps between them are.",
    description: "label printing help, calibration step",
  },
  calibrateStep2: {
    id: "cq6YNb",
    defaultMessage: "Do it again whenever labels start drifting over the gaps.",
    description: "label printing help, calibration step",
  },

  fadedTitle: {
    id: "+CefLV",
    defaultMessage: "Faded or grey prints",
    description: "label printing help, section title",
  },
  fadedStep1: {
    id: "Rfrv8o",
    defaultMessage:
      "Printing preferences → <b>Options</b>: raise <b>Darkness</b> a little at a time (around 20–25 usually works).",
    description: "label printing help, faded prints step",
  },
  fadedStep2: {
    id: "m8ZwQL",
    defaultMessage: "Lower <b>Speed</b> to <b>2 ips</b>: slower printing is darker.",
    description: "label printing help, faded prints step",
  },
  fadedStep3: {
    id: "y7wkXo",
    defaultMessage:
      "Too dark makes barcodes bleed and stop scanning: scan a barcode after each change.",
    description: "label printing help, faded prints step",
  },
  fadedStep4: {
    id: "3C1hpZ",
    defaultMessage:
      "On roll paper the dashboard already prints everything in pure black, so coloured logos come out solid.",
    description: "label printing help, faded prints step",
  },

  troubleTitle: {
    id: "bCY9lJ",
    defaultMessage: "Labels too small, turned or off the stickers",
    description: "label printing help, section title",
  },
  troubleStep1: {
    id: "P4QyUB",
    defaultMessage:
      "<b>Smaller and centred</b>: the printer's stock isn't the size shown next to “Copy size”, or the scale isn't Default. Changing Chrome's scale has no effect while the stock is wrong.",
    description: "label printing help, troubleshooting step",
  },
  troubleStep2: {
    id: "gijM1u",
    defaultMessage: "<b>Turned 90°</b>: switch the stock's orientation (Portrait ↔ Landscape).",
    description: "label printing help, troubleshooting step",
  },
  troubleStep3: {
    id: "3JnYKJ",
    defaultMessage:
      "<b>Shifted over the gaps</b>: calibrate first, then nudge the left margin or the gaps under <b>Adjust</b> by 0.5 mm.",
    description: "label printing help, troubleshooting step",
  },

  macTitle: {
    id: "0xXMis",
    defaultMessage: "Mac",
    description: "label printing help, section title",
  },
  macStep1: {
    id: "qO5vrF",
    defaultMessage:
      "In Chrome's print window choose <b>Print using system dialog</b> (⌥⌘P): custom paper sizes only appear there.",
    description: "label printing help, Mac step",
  },
  macStep2: {
    id: "GBqqkQ",
    defaultMessage:
      "<b>Paper Size → Manage Custom Sizes → +</b>: 102 × 62 mm with all margins 0. Select it and keep the scale at 100%.",
    description: "label printing help, Mac step",
  },
});
